var React = require('react');

function Printer (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.50928 2.64465H12.7908V4.46341H5.50928V2.64465Z","fill":"black","key":0}),React.createElement("path",{"d":"M15.5223 5.37598H2.77809C2.27648 5.37598 1.86871 5.78698 1.86871 6.28536V10.8355C1.86871 11.3371 2.27971 11.7449 2.77809 11.7449H5.50946V15.3856H12.791V11.7481H15.5223C16.0239 11.7481 16.4317 11.3371 16.4317 10.8387V6.28536C16.4317 5.78698 16.0207 5.37598 15.5223 5.37598ZM3.68747 8.10735C3.18586 8.10735 2.77809 7.69958 2.77809 7.19797C2.77809 6.69636 3.18586 6.28859 3.68747 6.28859C4.18908 6.28859 4.59685 6.69636 4.59685 7.19797C4.59685 7.69958 4.19232 8.10735 3.68747 8.10735ZM11.8816 14.4795H6.41884V9.9261H11.8816V14.4795Z","fill":"black","key":1})]);
}

Printer.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Printer;

Printer.default = Printer;
